import { render } from "./AppLoading.vue?vue&type=template&id=1496b490&scoped=true&lang=pug"
const script = {}

import "./AppLoading.vue?vue&type=style&index=0&id=1496b490&lang=scss&scoped=true"

import exportComponent from "/Users/edsonfer/Documents/dev-projects/node-projects/portal-gignet-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1496b490"]])

export default __exports__